/** MI DOMINO - the big table banner. Every banner is also a "big moment" the
 *  gallery reacts to (fan emoji, fiesta lights when the effect is owned). */
import { hasFx } from '../data/config';
import { fanReact, fiestaLights } from '../game/engine';

export function banner(txt: string): void {
  const b = document.getElementById('banner')!;
  b.textContent = txt;
  b.classList.add('show');
  setTimeout(() => b.classList.remove('show'), 1600);
  /* the gallery reacts to every big moment at the table */
  try {
    if (hasFx('fx-fiesta') && (txt.includes('CAPICÚ') || txt.includes('CHUCHAZO') || txt.includes('GANAN') || txt.includes('GANA LA'))) {
      fiestaLights();
    }
    if (txt.includes('CAPICÚ')) fanReact('🔥');
    else if (txt.includes('CHUCHAZO')) fanReact('🤯');
    else if (txt.includes('LA MANO')) fanReact('😱');
    else if (txt.includes('TRANQUE')) fanReact('😱');
    else if (txt.includes('DOMINÓ')) fanReact('👏');
    else if (txt.includes('GANAN') || txt.includes('GANA LA')) fanReact('🎉');
    else if (/TRAMPOSO|CHEATING/.test(txt)) fanReact('😂');
    else if (/NO VOY|PASS/.test(txt)) fanReact('😬');
  } catch (e) { /* the table never breaks over a reaction */ }
}
